import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.user');
import { OnInit, DoCheck, ChangeDetectorRef, OnChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'wiz-component-nav-user',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.user/view.scss */
/* src/app/component.nav.user/view.scss: no such file or directory */`],
})
export class ComponentNavUserComponent implements OnInit, OnChanges {
    constructor(@Inject( Service)         public service: Service,@Inject( ActivatedRoute)         private route: ActivatedRoute,@Inject( Router)         private router: Router,@Inject( ChangeDetectorRef)         private cdr: ChangeDetectorRef) { }

    public userMenu = [
        { id: 'dashboard', label: '대시보드', icon: 'Grip', path: '/dashboard', ctf: false },
        { id: 'notice', label: '공지사항', icon: 'Megaphone', path: '/notice', ctf: false },
        {
            id: 'support',
            label: '기술지원',
            icon: 'Wrench',
            children: [
                { id: 'manual', label: '매뉴얼', icon: 'FileLines', path: '/support/manual' },
                { id: 'ticketing', label: '티켓팅', icon: 'Ticket', path: '/support/ticketing' },
                { id: 'faq', label: 'FAQ', icon: 'Question', path: '/support/faq' }
            ],
            ctf: true
        },
        { id: 'research', label: '성과', icon: 'Chart', path: '/research', ctf: false },
        { id: 'board', label: '게시판', icon: 'Message', path: '/board', ctf: false },
        { id: 'storage', label: '스토리지', icon: 'Storage', path: '/storage', ctf: false },
        {
            id: 'group',
            label: '연구그룹',
            icon: 'Rectangle',
            children: [
                { id: 'list', label: '그룹 목록', icon: 'Bars', path: '/group/list' },
                { id: 'request', label: '요청 목록', icon: 'Envelope', path: '/group/request' }
            ],
            ctf: true
        },
        { id: 'mypage', label: '마이페이지', icon: 'User', path: '/mypage', ctf: false }
    ];

    public expandedMenus: Record<string, boolean> = {};

    public session: any;

    public userInfo: any = {
        account_name: '',
        email: '',
        roles: []
    };

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow();
        this.session = this.service.auth.session;
        await this.load();
        await this.service.render();
    }

    public async load() {
        const { code, data } = await wiz.call("load");
        if (code != 200) return await this.service.alert.error("Error!");
        this.userInfo = data;
        await this.service.render();
    }

    public hasAuth(roles: string) {
        roles = roles.split(",");
        return roles.includes(this.service.auth.session.role);
    }

    public manager(roleList: any) {
        let roles = roleList.join(' ');
        return roles.includes('서비스 담당자');
    }

    public async toggleMenu(menuId: string, event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        this.expandedMenus = {
            ...this.expandedMenus,
            [menuId]: !this.expandedMenus[menuId]
        };
        this.cdr.detectChanges();
        await this.service.render();
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    // lucide 이름 → Tabler 아이콘 클래스 매핑
    public getIconClass(iconName: string) {
        const map = {
            User: 'fa-solid fa-user',
            Users: 'fa-solid fa-users',
            Ticket: 'fa-solid fa-ticket',
            Settings: 'fa-solid fa-gear',
            LogOut: 'fa-solid fa-right-from-bracket',
            ChevronDown: 'fa-solid fa-chevron-down',
            Grip: 'fa-solid fa-grip',
            Clipboard: 'fa-solid fa-clipboard',
            Question: 'fa-solid fa-clipboard-question',
            FileLines: 'fa-solid fa-file-lines',
            Group: 'fa-solid fa-users-viewfinder',
            Rectangle: 'fa-solid fa-users-rectangle',
            Wrench: 'fa-solid fa-screwdriver-wrench',
            Chart: 'fa-solid fa-chart-column',
            Envelope: 'fa-solid fa-envelope-circle-check',
            Bars: 'fa-solid fa-bars',
            Megaphone: 'fa-solid fa-bullhorn',
            Message: 'fa-solid fa-message',
            Storage: 'fa-solid fa-box'
        };
        return map[iconName] || 'fa-solid fa-circle';
    }

    public async logout() {
        sessionStorage.clear();
        window.location.href = '/auth/logout';
    }
}

export default ComponentNavUserComponent;